export const API_URL = 'https://panel.d-ecosystem.io/'